/**
 * isiXhosa: Channels
 *
 * What this file covers: Website chat, SMS, email, USSD and the other channels clients reach the business on.
 *
 * Tone: Clear and practical. Say what the client sees on each channel.
 *
 * isiXhosa: Everyday isiXhosa as used in South African business. Keys not translated yet fall back to English,
 * so a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const channels: Catalog = {
  'channels.title': 'Iijelo',
  'channels.description': 'Iindawo abathengi abanokukubhalela kuzo, noko kuqhagamshelwe kuyo nganye.',
  'channels.connect': 'Qhagamshela iphepha',
  'channels.connected': '{{name}} iqhagamshelwe.',
  'channels.disconnected': 'Kuqhawuliwe.',
  'channels.check': 'Vavanya',
  'channels.check.ok': 'Konke oku kufunwa leli jelo kukho.',
  'channels.check.problems': 'Kukho into efuna ingqwalasela kweli jelo.',
  'channels.switchedOff': 'Kucinyiwe',
  'channels.receiving': 'Ifumana imiyalezo ukususela ngo-{{since}}',
  'channels.notReceiving': 'Ayikayifumani imiyalezo. Qhagamshela eli phepha kwakhona ukuze uvule ukuhanjiswa.',
  'channels.lastCheck.ok': 'Ivavanywe okokugqibela ngo-{{when}}: konke kulungile.',
  'channels.lastCheck.failed': 'Ivavanywe okokugqibela ngo-{{when}}: kukho into efuna ingqwalasela.',
  'channels.disconnect': 'Qhawula',
  'channels.disconnect.title': 'Uqhawula eli jelo?',
  'channels.disconnect.body': 'Imiyalezo emitsha eya ku-{{name}} iya kuyeka ukufika. Iincoko zakho ezikhoyo ziya kuhlala njengoko zinjalo, kwaye ungaqhagamshela kwakhona nangaliphi na ixesha.',
  'channels.disconnect.confirm': 'Qhawula',
  'channels.empty.title': 'Akukho ziakhawunti ze-Facebook okanye ze-Instagram okwangoku',
  'channels.empty.body': 'Qhagamshela iphepha le-Facebook ize ibhotyi yakho iphendule kwi-Messenger, nakwi-Instagram ngeakhawunti eqhagamshelwe kwelo phepha.',
  'channels.elsewhere.title': 'Ezinye iijelo zakho',
  'channels.elsewhere.whatsapp': 'Iinombolo ze-WhatsApp ziqhagamshelwa kwi-',
  'channels.elsewhere.website': 'Incoko yewebhusayithi isetyenzwa kwi-',
  'channels.connect.intro': 'Ngena kwi-Facebook uze ukhethe iphepha ofuna abathengi bakubhalele kulo. Sicela kuphela oko kufunekayo ukufunda elo phepha nokuphendula imiyalezo yalo.',
  'channels.connect.needs': 'Kufuneka ube ngumlawuli wephepha. Kwi-Instagram, iakhawunti kufuneka ibe yeyobungcali kwaye iqhagamshelwe kwelo phepha.',
  'channels.connect.signIn': 'Qhubeka nge-Facebook',
  'channels.connectMessenger': 'Qhagamshela i-Messenger',
  'channels.connectInstagram': 'Qhagamshela i-Instagram',
  'channels.alreadyConnected': 'Kuqhagamshelwe',
  'channels.instagram': 'Instagram',
  'channels.instagram.ready': 'Iakhawunti yobungcali iqhagamshelwe kweli phepha kwaye inokuqhagamshelwa.',
  'channels.instagram.personal': 'Iakhawunti ye-Instagram kweli phepha yeyobuqu. Yitshintshele kwiakhawunti yobungcali kwi-app ye-Instagram uze ubuye.',
  'channels.instagram.none': 'Akukho akhawunti ye-Instagram eqhagamshelwe kweli phepha okwangoku.',
  'channels.cannotMessage': 'Awukwazi ukuthumela imiyalezo kweli phepha. Cela lowo uliphetheyo akunike indima yemiyalezo.',
  'channels.cannotSubscribe': 'Awukwazi ukuvula ukuhanjiswa kwemiyalezo kweli phepha. Cela lowo uliphetheyo akwenze umlawuli.',
  'channels.noPages.title': 'Akukho maphepha kule akhawunti',
  'channels.noPages.body': 'Le akhawunti ye-Facebook ayilawuli maphepha. Ngena ngeakhawunti enawo.',
  'channels.unavailable.title': 'Ayikavulwa okwangoku',
  'channels.unavailable.body': 'Ukuqhagamshela iphepha le-Facebook akukavulwa okwangoku. Sazisiwe, kwaye ezinye iijelo zakho ziyaqhubeka ngesiqhelo.',
  'channels.sdk.title': 'I-Facebook ayifikelelekanga',
  'channels.sdk.blocked': 'Ukungena kwi-Facebook akukwazanga ukulayisha. Ngokuqhelekileyo kubangelwa ngumthinteli womxholo okanye isicwangciso esiqinileyo sabucala; zama kwakhona kwifestile eqhelekileyo.',
  'channels.sdk.unavailable': 'Ukungena kwi-Facebook akukwazanga ukulayisha. Jonga uqhagamshelwano lwakho uze uzame kwakhona.',
  'channels.sdk.noToken': 'I-Facebook ayikugqibanga ukungena. Akukho nto iqhagamshelweyo; zama kwakhona.'
};

export default channels;
